import { cn } from "@/lib/utils";
import { PictureUpload } from "../picture-upload/picture-upload";
import { ImageHoverWrapper } from "../image-hover-wrapper";
import { ReactNode } from "react";

export const VerticalCard = ({
  image,
  title,
  subtitle,
  extras,
  absoluteExtras,
  tag,
  button,
  hoverIcon,
  className,
}: {
  image: ImageVM;
  title: string;
  subtitle?: string;
  extras?: ReactNode;
  absoluteExtras?: ReactNode;
  button?: ReactNode;
  tag?: string;
  hoverIcon?: ReactNode;
  className?: string;
}) => (
  <div
    className={cn(
      "group relative flex h-full flex-1 justify-center self-stretch bg-white",
      className,
    )}
  >
    <div className="border-base flex h-full flex-col overflow-hidden rounded-xl border">
      <div className="aspect-[1.91 / 1] relative w-full overflow-hidden rounded-b-sm">
        <ImageHoverWrapper rounded="rounded-none">
          <PictureUpload image={image} type={"card"} />
        </ImageHoverWrapper>
        {absoluteExtras}
        {tag && (
          <div className="bg-remedium-blue absolute top-3 left-3 rounded-md px-2 py-0.5 text-xs font-semibold text-white uppercase">
            {tag}
          </div>
        )}
        {hoverIcon && (
          <div className="absolute top-0 left-0 z-20 flex h-full w-full cursor-pointer items-center justify-center opacity-0 transition group-hover:opacity-75">
            <div className="flex h-10 w-10 scale-75 transform items-center justify-center rounded-lg bg-white backdrop-blur-2xl transition-transform duration-200 group-hover:scale-100">
              {hoverIcon}
            </div>
          </div>
        )}
      </div>
      <div className="flex flex-1 flex-col justify-between p-4">
        <div className="flex flex-1 flex-col">
          <p className="mb-2 font-[550] text-[#18181B]">{title}</p>
          {subtitle && (
            <p className="text-muted-foreground text-sm">{subtitle}</p>
          )}
          {extras}
        </div>
        {button && <div className="relative z-20 w-full">{button}</div>}
      </div>
    </div>
  </div>
);
